import { render } from "./App.vue?vue&type=template&id=bd3137ce"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=bd3137ce&lang=css"
script.render = render

export default script